import { z } from 'zod';

export type ActionType =
  | 'alert_dialog'
  | 'action_list_dialog'
  | 'open_link'
  | 'message_box'
  | 'full_screen_dialog';


export const ACTION_TYPES: ActionType[] = [
  'alert_dialog',
  'action_list_dialog',
  'open_link',
  'message_box',
  'full_screen_dialog',
];


export type OpenLinkOpenMethod = 'in_app' | 'browser' | 'deep_link';

export const OPEN_LINK_OPEN_METHODS: OpenLinkOpenMethod[] = [
  'in_app',
  'browser',
  'deep_link',
];

const OpenLinkActionSchema = z.object({
  type: z.literal('open_link'),
  attribute_schema: z.object({
    url: z.string(),
    open_method: z.enum(OPEN_LINK_OPEN_METHODS),
  }),
});
export type OpenLinkAction = z.infer<typeof OpenLinkActionSchema>;

export const MessageBoxActionSchema = z.object({
  type: z.literal('message_box'),
  attribute_schema: z.object({
    title: z.string(),
    message: z.string(),
    positive_button: z.string(),
    image: z.string(),
  }),
});
export type MessageBoxAction = z.infer<typeof MessageBoxActionSchema>;

export const AlertDialogActionSchema = z.object({
  type: z.literal('alert_dialog'),
  attribute_schema: z.object({
    title: z.string(),
    message: z.string(),
    positive_button: z.string(),
    negative_button: z.string(),
    image: z.string(),
    get action() {
      return ActionSettingSchema;
    },
  }),
});
export type AlertDialogAction = z.infer<typeof AlertDialogActionSchema>;


export const ActionListDialogActionSchema = z.object({
  type: z.literal('action_list_dialog'),
  attribute_schema: z.object({
    title: z.string(),
    message: z.string(),
    image: z.string(),
    get actions() {
      return z.array(
        z.object({
          button_name: z.string(),
          action: ActionSettingSchema,
        }),
      );
    },
  }),
});

export type ActionListDialogAction = z.infer<
  typeof ActionListDialogActionSchema
>;

export type ActionListDialogSubAction =
  ActionListDialogAction['attribute_schema']['actions'][number];

export const FullScreenDialogActionSchema = z.object({
  type: z.literal('full_screen_dialog'),
  attribute_schema: z.object({
    image: z.string(),
    get action() {
      return ActionSettingSchema;
    },
  }),
});

export type FullScreenDialogAction = z.infer<
  typeof FullScreenDialogActionSchema
>;

export const ActionSettingSchema = z.discriminatedUnion('type', [
  OpenLinkActionSchema,
  MessageBoxActionSchema,
  AlertDialogActionSchema,
  ActionListDialogActionSchema,
  FullScreenDialogActionSchema,
]);

export type ActionSetting = z.infer<typeof ActionSettingSchema>;
